import { render } from "./FixPDC.vue?vue&type=template&id=8a4888e6&scoped=true"
import script from "./FixPDC.vue?vue&type=script&lang=js"
export * from "./FixPDC.vue?vue&type=script&lang=js"

import "./FixPDC.vue?vue&type=style&index=0&id=8a4888e6&scoped=true&lang=css"
import "./FixPDC.vue?vue&type=style&index=1&id=8a4888e6&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4888e6"]])

export default __exports__